// import '../styles/main.scss';

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import collapse from '@alpinejs/collapse';

// Import Swiper
import Swiper from 'swiper';
// import 'swiper/swiper-bundle.css';
import { Navigation, Pagination } from 'swiper/modules';

import '../components/alp-main-store';
import '../components/alp-cart';
import '../components/alp-build-box'; // FE TODO Must be included only for the build box section

window.Alpine = Alpine;
window.Swiper = Swiper;
Swiper.use([Navigation, Pagination]);

Alpine.plugin(persist);
Alpine.plugin(collapse);
Alpine.start();

import { variantSelect } from '../components/variant-select';
import { headerSticky } from '../components/header';

import { initAccordion } from '../components/initAccordion';
import { caruselImages } from '../components/carusel-images';
import { productCarousel } from '../components/carusel-product';
import { initCustomVideo } from '../scripts/sections/custom-video';
import { initLifetimeGuaranteeModal } from '../scripts/sections/lifetime-guarantee-modal';
import { initOurValuesSection } from '../scripts/sections/our-values';
// import { initWordReveal } from '../components/animations';
//
// document.addEventListener('DOMContentLoaded', () => {
//     initWordReveal({
//       className: 'word-reveal',  // або свій клас
//       delayUnit: 80,             // якщо хочеш іншу «швидкість»
//       threshold: 0.1            // трохи більше «психологічного» порогу
//     });
//   });


document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.querySelector('.l-overlay__modals');
    if (!overlay) return; // якщо не знайдено — вихід

    // спочатку перевіримо поточний стан
    toggleOverlay();

    // створюємо обсервер, який слухає атрибути class по всьому body
    const observer = new MutationObserver(toggleOverlay);
    observer.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });

    function toggleOverlay() {
        const isModalVisible = !!document.querySelector('.js-modal-show, .js-modal-closing');
        overlay.style.display = isModalVisible ? 'block' : 'none';
    }
});



headerSticky();
variantSelect();
initAccordion();
caruselImages();
productCarousel();
initCustomVideo();
initLifetimeGuaranteeModal();
initOurValuesSection();
